import * as amplitude from '@amplitude/analytics-browser';

const getEnvironment = () => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        return 'dev';
    } else {
        return 'prod';
    }
};

export const useAnalytics = () => {
    const track = (eventName: string, props?: Record<string, string>) => {
        amplitude.track(eventName, {
            ...props,
            hostname: window.location?.hostname,
            path: window.location?.pathname,
            environment: getEnvironment()
        });
    };

    return {
        track
    };
};
